import Contract from './contract.view.vue';
import ContractDataTable from './contract-datatable/contract-datatable.component.vue';
import ContractInfo from './contract-info/contract-info.component.vue';
import ContractHistory from './contract-history/contract-history.component.vue';
import ManageCalculation from './manage-calculation/manage-calculation.vue';

export default [
  {
    path: '/contracts',
    component: Contract,
    children: [
      {
        path: '/contracts',
        name: 'ContractDataTable',
        component: ContractDataTable,
      },
      {
        path: '/contracts/:status/:competence?',
        name: 'ContractDataTableStatus',
        component: ContractDataTable,
      },
      {
        path: '/contract/:id',
        name: 'Contrato',
        component: ContractInfo,
      },
      {
        path: '/contract/:id/history',
        name: 'HistóricoContrato',
        component: ContractHistory,
      },
      {
        path: '/contract/manage-calculation/:id',
        props: true,
        name: 'GestaoContrato',
        component: ManageCalculation,
      },
    ],
  },
];
